import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { StorageService } from './local-storage.service';
 
import { Session } from '../models/session.model';
import * as moment from 'moment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userData: any;
  auth_token: string = ""
  constructor(
    public storage: StorageService,
    public router: Router,
    public httpClient: HttpClient,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    // Setting logged in user in localstorage else null

    if (this.storage.getCurrentSession()) {

      this.userData = this.storage.getCurrentSession();

      this.storage.setCurrentSession(this.userData)

    } else {

      this.storage.setCurrentSession(null)

    }

  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    return this.storage.isAuthenticated();
  }


  // Sign out 
  SignOut() {
    this.storage.logout()

  }

  // Sign In
  login(data) {
    var promise = new Promise<void>((resolve, reject) => {
      
      console.log({
        apiUrl: environment.apiUrl+"/api/Login",
        data,
        JSON: JSON.parse(data)
      });

      this.httpClient.post( environment.apiUrl+"/api/Login", JSON.parse(data)).subscribe((data: any) => {
        var session: Session = {
          "token": data.token,
          "user": {
            "userName": data.response.userName,
            "name": data.response.fullName,
            "rolName": data.response.rol,
            "lastSession": moment().format("DD/MM/YYYY hh:mm")
          }
        }
         
        this.storage.setCurrentSession(session);

        resolve(data.response);
      }, err => reject(err),
      );
    })
    return promise
  }
  updatePassword(data) {
    this.auth_token = this.storage.getCurrentToken()
    var promise = new Promise<void>((resolve, reject) => {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.auth_token}`
      })

      this.httpClient.put( environment.apiUrl + "/userpwd", data).subscribe((data: any) => {
        resolve(data)
      }, err => reject(err)
      );
    })
    return promise
  }
}